import React, { useState, useEffect } from 'react';
import { FaWallet, FaMoneyBillWave, FaPiggyBank, FaArrowCircleUp, FaHistory } from 'react-icons/fa';
import { GetUserWallet, GetWalletTransactions } from '../../services/Payments.ts';
import Loader from '../../components/Loader.tsx';
import TransferMoneyPopup from '../../components/TransferMoneyPopUp.tsx';
import { useTheme } from "../../contexts/ThemeContext.tsx";
import { themes } from '../../theme.ts';

const Wallet = () => {
    const { themeName } = useTheme();
    const currentTheme = themes[themeName].colors;
    // Dummy data - replace with your API calls later
    const [balance, setBalance] = useState(12500);
    const [allocated, setAllocated] = useState(3750);
    const [depositAmount, setDepositAmount] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [wallet, setWallet] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [allTransactions, setAllTransactions] = useState<any[]>([]);

    const rawData = localStorage.getItem('user');
    const cred = rawData ? JSON.parse(rawData) : null;
    const token = cred?.access;
    const id = cred?.user?.id;

    const [showTransferPopup, setShowTransferPopup] = useState(false);
    const [selectedInfluencer, setSelectedInfluencer] = useState<any | null>(null);

    // Example influencer data
    const influencer = {
        id: 'inf_123',
        name: 'Alex Johnson',
        profilePic: 'https://example.com/profile.jpg',
    };

    const handleTransfer = (transferData: any) => {
        console.log('Transfer initiated:', transferData);
        // Here you would call your API to process the transfer
        // Then update your wallet balance and transactions
    };

    const getWalletInfo = async () => {
        try {
            const response: any = await GetUserWallet(token, id);
            setWallet(response?.data);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getWalletInfo();
    }, []);

    const getwalletTransactionDetails = async () => {
        setLoading(true);
        if (wallet) {
            try {
                const response: any = await GetWalletTransactions(token, wallet?.id);
                console.log('transaction response', response);
                setAllTransactions(response?.data || []);
                setLoading(false);
            } catch (err) {
                console.log(err);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        getwalletTransactionDetails();
    }, [wallet]);

    const handleDeposit = () => {
        if (!depositAmount || isNaN(Number(depositAmount)) || Number(depositAmount) <= 0) {
            alert('Please enter a valid amount');
            return;
        }

        setIsProcessing(true);

        // Simulate API call
        setTimeout(() => {
            setBalance(balance + Number(depositAmount));
            setDepositAmount('');
            setIsProcessing(false);

            // Add to transactions (in a real app, this would come from API response)
            setAllTransactions(prev => [
                {
                    id: Date.now(),
                    date: new Date().toISOString().split('T')[0],
                    description: 'Deposit via Razorpay',
                    amount: Number(depositAmount),
                    status: 'completed',
                },
                ...prev,
            ]);

            alert('Funds added successfully!');
        }, 1500);
    };

    return (
        <div className="container mx-auto" style={{ backgroundColor: currentTheme.background }}>

            {/* Balance Cards */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                <div className="p-6 rounded-xl shadow-sm" style={{ backgroundColor: currentTheme.surface }}>
                    <div className="flex items-center gap-3 mb-2">
                        <FaWallet className="text-xl" style={{ color: currentTheme.secondary }} />
                        <h3 style={{ color: currentTheme.textSecondary, fontWeight: 500 }}>Total Balance</h3>
                    </div>
                    <p className="text-3xl font-bold" style={{ color: currentTheme.text }}>
                        ₹{wallet?.total_balance}
                    </p>
                </div>

                <div className="p-6 rounded-xl shadow-sm" style={{ backgroundColor: currentTheme.surface }}>
                    <div className="flex items-center gap-3 mb-2">
                        <FaMoneyBillWave className="text-xl" style={{ color: currentTheme.accent }} />
                        <h3 style={{ color: currentTheme.textSecondary, fontWeight: 500 }}>Pending</h3>
                    </div>
                    <p className="text-3xl font-bold" style={{ color: currentTheme.text }}>
                        ₹{wallet?.pending_amount}
                    </p>
                </div>

                <div className="p-6 rounded-xl shadow-sm" style={{ backgroundColor: currentTheme.surface }}>
                    <div className="flex items-center gap-3 mb-2">
                        <FaPiggyBank className="text-xl" style={{ color: currentTheme.primary }} />
                        <h3 style={{ color: currentTheme.textSecondary, fontWeight: 500 }}>This Month</h3>
                    </div>
                    <p className="text-3xl font-bold" style={{ color: currentTheme.text }}>
                        ₹{wallet?.total_this_month}
                    </p>
                </div>

                <div className="p-6 rounded-xl shadow-sm" style={{ backgroundColor: currentTheme.surface }}>
                    <div className="flex items-center gap-3 mb-2">
                        <FaPiggyBank className="text-xl" style={{ color: currentTheme.primary }} />
                        <h3 style={{ color: currentTheme.textSecondary, fontWeight: 500 }}>Withdrawn</h3>
                    </div>
                    <p className="text-3xl font-bold" style={{ color: currentTheme.text }}>
                        ₹{wallet?.total_withdraw}
                    </p>
                </div>
            </div>

            {/* Deposit Section */}
            {/* <div className="bg-white rounded-xl shadow-md p-6 mb-8">
                                <div className="flex justify-end">
                    <button
                        onClick={() => {
                            setSelectedInfluencer(influencer);
                            setShowTransferPopup(true);
                        }}
                        className="bg-gradient-to-r from-primary-500 to-primary-700 text-white px-4 py-2 rounded-lg"
                    >
                        Pay Influencer
                    </button>
                    </div>
                <h2 className="text-xl font-bold text-gray-800 mb-4">Add Funds</h2>
                <div className="flex flex-col md:flex-row gap-4">
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Amount (₹)</label>
                        <input
                            type="number"
                            value={depositAmount}
                            onChange={(e) => setDepositAmount(e.target.value)}
                            placeholder="Enter amount"
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary-500"
                            disabled={isProcessing}
                        />
                    </div>
                    <div className="flex items-end">
                        <button
                            onClick={handleDeposit}
                            disabled={isProcessing}
                            className="bg-gradient-to-r from-primary-500 to-primary-700 hover:opacity-90 text-white px-6 py-2 rounded-lg flex items-center gap-2"
                        >
                            <FaArrowCircleUp />
                            {isProcessing ? (
                                <span className="flex items-center">
                                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Processing...
                                </span>
                            ) : 'Deposit'}
                        </button>
                    </div>
                </div> */}

            {/* <TransferMoneyPopup
                        isOpen={showTransferPopup}
                        onClose={() => setShowTransferPopup(false)}
                        onTransfer={handleTransfer}
                        influencer={selectedInfluencer}
                    />
            </div> */}


            <>
                {loading ?
                    <Loader />
                    :
                    <div className="rounded-xl shadow-md overflow-hidden p-6" style={{ backgroundColor: currentTheme.surface }}>
                        <h2 className="text-xl font-bold mb-4 flex items-center gap-2" style={{ color: currentTheme.text }}>
                            <FaHistory /> Transaction History
                        </h2>

                        {allTransactions?.length > 0 ? (
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y" style={{ borderColor: currentTheme.border }}>
                                    <thead style={{ backgroundColor: currentTheme.primary }}>
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: currentTheme.inverseText }}>Date</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: currentTheme.inverseText }}>Description</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: currentTheme.inverseText }}>Amount</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: currentTheme.inverseText }}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ backgroundColor: currentTheme.surface }}>
                                        {allTransactions.map((txn) => (
                                            <tr key={txn.id} style={{ borderColor: currentTheme.border }}>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm" style={{ color: currentTheme.textSecondary }}>
                                                    {new Date(txn.date).toLocaleDateString('en-IN')}
                                                </td>
                                                <td className="px-6 py-4 text-sm" style={{ color: currentTheme.text }}>
                                                    {txn.description}
                                                </td>
                                                <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium`} style={{ color: txn.amount > 0 ? currentTheme.success : currentTheme.error }}>
                                                    {txn.amount > 0 ? '+' : ''}₹{Math.abs(txn.amount).toLocaleString('en-IN')}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full`} style={{
                                                        backgroundColor: txn.status === 'completed' ? currentTheme.success + '33' : txn.status === 'failed' ? currentTheme.error + '33' : currentTheme.warning + '33',
                                                        color: txn.status === 'completed' ? currentTheme.success : txn.status === 'failed' ? currentTheme.error : currentTheme.warning
                                                    }}>
                                                        {txn.status.charAt(0).toUpperCase() + txn.status.slice(1)}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <p className="py-4 text-center" style={{ color: currentTheme.textSecondary }}>No transactions yet</p>
                        )}
                    </div>
                }
            </>
        </div>
    );
};

export default Wallet;
